import { Grid, TextField } from "@material-ui/core";
import React, { forwardRef, useImperativeHandle } from "react";
import { Controller, useForm } from "react-hook-form";

const SupplementaryInfoForm = forwardRef((props, ref) => {
  const { onSubmitForm, defaultValues = [], mode = "new", loading = false } = props;

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
  } = useForm({
    defaultValues: defaultValues,
  });

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitForm)(),
    isSubmitSuccessful: () => isSubmitSuccessful,
  }));

  const validate = (evt) => {
    var theEvent = evt || window.event;
    var key;
    // Handle paste
    if (theEvent.type === "paste") {
      key = theEvent.clipboardData.getData("text/plain");
    } else {
      // Handle key press
      key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /[^0-9۰-۹]/g;
    if (regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction='row' spacing={1}>
        <Grid item xs={12} lg={3}>
          <Controller
            name='enclosure_value'
            control={control}
            // rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label='ارزش محوطه سازی'
                size='small'
                margin='dense'
                variant='outlined'
                // type='number'
                error={errors.enclosure_value}
                helperText={errors.enclosure_value && "فیلد نمیتواند خالی باشد"}
                fullWidth
                onKeyPress={validate}
                onChange={(e) =>
                  field.onChange({
                    ...e,
                    target: { value: e?.target?.value?.split(",")?.join("")?.toEnglishDigits() },
                  })
                }
                value={field?.value?.toString()?.toCurrencyFormat()?.toPersianDigits()}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={9}>
          <Controller
            name='enclosure_description'
            control={control}
            // rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label='توضیحات محوطه سازی'
                size='small'
                margin='dense'
                variant='outlined'
                error={errors.enclosure_description}
                helperText={errors.enclosure_description && "فیلد نمیتواند خالی باشد"}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name='credits_sum'
            control={control}
            // rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label='ارزش امتیازات'
                size='small'
                margin='dense'
                variant='outlined'
                // type='number'
                error={errors.credits_sum}
                helperText={errors.credits_sum && "فیلد نمیتواند خالی باشد"}
                fullWidth
                onKeyPress={validate}
                onChange={(e) =>
                  field.onChange({
                    ...e,
                    target: { value: e?.target?.value?.split(",")?.join("")?.toEnglishDigits() },
                  })
                }
                value={field?.value?.toString()?.toCurrencyFormat()?.toPersianDigits()}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={9}>
          <Controller
            name='credits_description'
            control={control}
            // rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label='توضیحات امتیازات'
                size='small'
                margin='dense'
                variant='outlined'
                error={errors.credits_description}
                helperText={errors.credits_description && "فیلد نمیتواند خالی باشد"}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
    </form>
  );
});

export default SupplementaryInfoForm;
